"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyzeReportHtmlResult = exports.AnalyzeReportHtmlStats = exports.AnalyzeStats = exports.AnalyzeReportLevel = exports.AnalyzeHistory = exports.AnalyzeReport = exports.AnalyzeReportResult = exports.AnalyzeReportRuleSummary = exports.AnalyzeReportRule = exports.AnalyzeReportViolation = exports.RuleViolation = exports.RuleConf = exports.ruleLevelsShown = exports.RuleLevel = exports.RuleName = exports.RuleId = void 0;
const zod_1 = require("zod");
const common_1 = require("../common");
const database_1 = require("../database");
const connector_1 = require("../interfaces/connector");
exports.RuleId = zod_1.z.string();
exports.RuleName = zod_1.z.string();
exports.RuleLevel = zod_1.z.enum(["high", "medium", "low", "hint", "off"]); // from highest to lowest
exports.ruleLevelsShown = exports.RuleLevel.options.filter(l => l !== exports.RuleLevel.enum.off);
exports.RuleConf = zod_1.z.object({
    level: exports.RuleLevel,
}).strict().describe("RuleConf");
exports.RuleViolation = zod_1.z.object({
    ruleId: exports.RuleId,
    ruleName: exports.RuleName,
    ruleLevel: exports.RuleLevel,
    message: zod_1.z.string(),
    // entity & attribute allow to locate the violation
    entity: database_1.EntityRef.optional(),
    attribute: database_1.AttributePath.optional(),
    // extra allow to keep structured information about the violation
    extra: zod_1.z.record(zod_1.z.any()).optional(),
}).strict();
exports.AnalyzeReportViolation = zod_1.z.object({
    message: zod_1.z.string(),
    entity: database_1.EntityRef.optional(),
    attribute: database_1.AttributePath.optional(),
    extra: zod_1.z.record(zod_1.z.any()).optional(),
}).strict().describe("AnalyzeReportViolation");
exports.AnalyzeReportRule = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(), // optional for retro-compatibility
    level: exports.RuleLevel,
    conf: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
    violations: exports.AnalyzeReportViolation.array(),
    totalViolations: zod_1.z.number(),
}).strict().describe("AnalyzeReportRule");
exports.AnalyzeReportRuleSummary = zod_1.z.object({
    name: zod_1.z.string(),
    totalViolations: zod_1.z.number(),
}).strict().describe("AnalyzeReportRuleSummary");
exports.AnalyzeReportResult = zod_1.z.record(exports.RuleId, exports.AnalyzeReportRule);
exports.AnalyzeReport = zod_1.z.object({
    analysis: exports.AnalyzeReportResult,
    // TODO: insights: z.object({mostUsedEntities: z.object({entity: EntityRef, queries: QueryId.array()}).array().optional()}).optional()
    database: database_1.Database,
    queries: connector_1.DatabaseQuery.array(),
}).strict().describe("AnalyzeReport");
exports.AnalyzeHistory = zod_1.z.object({
    report: zod_1.z.string(),
    date: common_1.Timestamp,
    database: database_1.Database,
    queries: connector_1.DatabaseQuery.array(),
}).strict().describe("AnalyzeHistory");
exports.AnalyzeReportLevel = zod_1.z.object({
    level: exports.RuleLevel,
    levelViolationsCount: zod_1.z.number(),
    rules: zod_1.z.array(exports.AnalyzeReportRule),
});
exports.AnalyzeStats = zod_1.z.object({
    nb_entities: zod_1.z.number(),
    nb_relations: zod_1.z.number(),
    nb_queries: zod_1.z.number(),
    nb_types: zod_1.z.number(),
    nb_rules: zod_1.z.number(),
    nb_violations: zod_1.z.number(),
    violations: zod_1.z.record(exports.RuleLevel, zod_1.z.number()),
});
exports.AnalyzeReportHtmlStats = zod_1.z.object({
    nb_entities: zod_1.z.number(),
    nb_relations: zod_1.z.number(),
    nb_queries: zod_1.z.number(),
    nb_types: zod_1.z.number(),
    nb_rules: zod_1.z.number(),
});
exports.AnalyzeReportHtmlResult = zod_1.z.object({
    rules: zod_1.z.array(exports.AnalyzeReportRule),
    stats: exports.AnalyzeReportHtmlStats,
});
//# sourceMappingURL=rule.js.map